<template>
  <div class="panel-header">
    <div class="header-slot left">
      <v-btn icon color="graydark" @click="$emit('click')">
        <v-icon>menu_open</v-icon>
      </v-btn>
      <router-link :to="{ path: '/' }">
        <div class="brand"></div>
      </router-link>
    </div>
    <div class="header-slot right">
      <slot name="buttons"></slot>
      <div class="avatar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeNavigationDrawerPrepend',
  props: {
    homeViewMode: undefined,
    hasActiveFilters: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/navigationDrawer-v2.scss';
@import '@/assets/scss/inputs.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/theme-v2.scss';
</style>
